import {
  DAY_KEY,
  getByIdDaysSelector,
  getValueReduxUtil
} from '@gymaholic/packages'
import Text from 'components/Text'
import React from 'react'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import { formatRelativeWithoutTimeDateUtil } from 'packages/src'
import Row from 'components/Row.js'
import { View } from 'components/View.js'
import { isCompletedByIdDaySelector } from 'modules/day/redux/selectors/isCompletedById/index.js'

/**
 * @param plannedAtStr
 * @returns {Element}
 * @constructor
 */
export function PlanDayRowPlannedAt ({
  id
}) {
  const day = useSelector(getByIdDaysSelector(id))
  const plannedAtStr = getValueReduxUtil(day, DAY_KEY.PLANNED_AT)
  const plannedAt = new Date(plannedAtStr)
  const plannedAtLabel = formatRelativeWithoutTimeDateUtil(plannedAt)

  const isCompleted = useSelector(isCompletedByIdDaySelector(id))
  const textProps = {
    fs: '11px',
    c: '#7F8D94',
    fw: '590',
    style: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      textTransform: 'uppercase'
    }
  }
  return (
    <Row>
      <Text
        ml
        {...textProps}
      >
        {plannedAtLabel}
      </Text>

      {
        !!isCompleted && (
          <View ml>
            <Text {...textProps}>✅</Text>
          </View>
        )
      }
    </Row>
  )
}
